// import IconButton  from '@material-ui/core/IconButton';
// import EditIcon  from '@material-ui/icons/Edit';
import { useState, useEffect } from 'react';
import { FaEdit, FaFileUpload } from 'react-icons/fa';
import PortalLayout from "./PortalLayout";
import M from 'materialize-css/dist/js/materialize.min';
import { connect } from 'react-redux';
import { useFirebase } from 'react-redux-firebase';
import { addProfileAction } from '../../Firebase/actions/addProfileAction';
import CustomizedSnackbars from '../Feedback';


const Personalnfo = ({ profile, addProfileAction, addProfileSuccess, addProfileError, id, resetSuccess}) => {

    const [selectFile, setSelectedFile ] = useState(null);
    const [preview, setPreview ] = useState('');
    const [ error, setError ] = useState(null);
    

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const firebase = useFirebase();

    const handlEditPic = () => {
        document.querySelector('#editInput').click();
    }

    //profile toggler
    let imgTag;
    if(profile) {
        if(profile.imageUrl !== undefined || !preview) {
            imgTag = <img  src={profile.imageUrl}  alt="ProfilePicture" className="logo-form grey lighten-3"  />
        }
    
        if(profile.imageUrl === undefined || preview) {
            imgTag =  <img src={preview} onError={(e) => setCurrentImage(e)} alt="ProfilePicture"  className="logo-form grey lighten-3" />
        }
    }
    
    const setCurrentImage = (e) => {
        if (!profile.imageUrl) {
            e.target.src="img/placeholder.svg";
        } 
    }

    const upDateImage = () => {
        // storagee references
        const storageRef = firebase.storage().ref(`profiles/${profile.idNumber}`);

        storageRef.put(selectFile).on('state change', (snap) => {
            document.getElementById('Btn').classList.add('is-loading');
        }, (err) => {
            setError(err.message);
        }, async () => {

            const uploadedFileUrl = await storageRef.getDownloadURL();
            //console.log(uploadedFileUrl);
            //document.getElementById('Btn').classList.remove('is-loading');
            let data = {
                collection: 'students',
                id,
                url: uploadedFileUrl
            }
            addProfileAction(data);
        }); 

        //set preview to empty string and set notification
    }
    

    useEffect(() => {
        //tooltip init
        var tp = document.querySelector('.tooltipped');
        M.Tooltip.init(tp, {});

        if(selectFile) {
            if(selectFile.type.substr(0,5) !== "image") {
                setSelectedFile(null);
            }
        }
        
      
        if(selectFile) {
            if(selectFile.size > 2000000) {
                document.getElementById('Btn').classList.remove('is-loading');
                setError(true);
                setSelectedFile(null);
            } else {
                setError(false);
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreview(reader.result);
                }
                reader.readAsDataURL(selectFile);
            }   
        } else {
            setPreview('');
        }

        if(addProfileSuccess) {
            //on success
            setFeedbackText('Profile Updated.');
            setSeverity('success');
            setOpenFeedback(true);
            setPreview('');
            setSelectedFile(null);
            
            resetSuccess();
        }

        if(addProfileError) {
            document.getElementById('Btn').classList.remove('is-loading');
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);
        }

        
        
    }, [ selectFile, addProfileSuccess, addProfileError, resetSuccess])

    return ( 
        <PortalLayout>
            {
                profile && (
                    <div className="row pt-5">
                        <div className="col s12 m6 l5 mb-4">
                            <div className="container">
                                <div className="center">
                                    {imgTag}
                                    {
                                        // true  && (
                                        //     <IconButton 
                                        //         onClick={handlEditPic} 
                                        //         className="tooltipped grey lighten-4 py-1 px-1 mb-4 edit-icon" size="small"
                                        //         data-tooltip="Edit Profile Picture"
                                            
                                        //     >
                                        //         <EditIcon className="main-blue"  />
                                        //     </IconButton>
                                        // )
                                    }
                                </div>
                                <input 
                                    type="file" 
                                    onChange={(e) => setSelectedFile(e.target.files[0])}
                                    hidden="hidden"
                                    id="editInput"
                                    accept="image/*"
                                />
                                <div className="center mb-5">
                                    {
                                        selectFile !== null && (
                                            <div 
                                                to="/" className="button is-success is-small border-none"
                                                onClick={upDateImage}
                                                id="Btn"
                                            >
                                                <span className="icon">
                                                    <FaFileUpload color="white"/>
                                                </span>
                                                <span className="white-text">Update</span>
                                            </div>
                                        )
                                    }
                                    <div 
                                        onClick={handlEditPic} 
                                        className="button is-success is-small border-none"
                                        data-tooltip="Edit Profile Picture"
                                    >
                                        <span className="icon">
                                            <FaEdit color="white"/>
                                        </span>
                                        <span className="white-text">Edit</span>
                                    </div>
                                    {
                                        error && <p className="main-color-text tiny-text mt-5">Sorry, Image size can't be larger than 2MB.</p>
                                    }
                                </div>
                            </div>
                            <div className="student-name center">
                                <p className="is-size-5 mb-3">{profile.title} {profile.forenames} {profile.surname}</p>
                                <p className="is-size-6 grey-text text-lighten-1 mb-3">{profile.email}</p>
                                <p className="is-size-6">{profile.programme}</p>
                            </div>
                        </div>
                        <div className="col s12 m6 l5">
                            <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">Personal Information</h5>
                            <div className="divider mb-5"></div>
                            <div className="details">
                                <p className="is-size-6 grey-text text-darken-2 mb-3">Date of Birth: {profile.dob}</p>
                                <p className="is-size-6 grey-text text-darken-2 mb-3">National ID: {profile.idNumber}</p>
                                <p className="is-size-6 grey-text text-darken-2 mb-3">Gender: {profile.gender}</p>
                                <p className="is-size-6 grey-text text-darken-2 mb-3">Marital Status: {profile.maritalStatus}</p>
                                <p className="is-size-6 grey-text text-darken-2 mb-3">Citizenship: {profile.citizenship}</p>
                                <p className="is-size-6 grey-text text-darken-2 mb-3">Nationality: {profile.nationality}</p>
                                <p className="is-size-6 grey-text text-darken-2 mb-3">Address: {profile.address}</p>
                            </div>
                        </div>
                    </div>
                )
            }
            
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </PortalLayout>
     );
}
 

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        addProfileSuccess: state.addProfile.addProfileSuccess,
        addProfileError: state.addProfile.addProfileError,
        profile: state.firebase.profile,
        id: state.firebase.auth.uid
    }   
    
}
 

const mapDispatchToProps = (dispatch) => { 
    return {
        addProfileAction: (data) => dispatch(addProfileAction(data)),
        resetSuccess: () => dispatch({ type: "ADD_PROFILE", success: false })
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(Personalnfo);
